
var appJs = {};

(function (appJsApp) {

    appJsApp.InitializeFadeIn = function () {
        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting === true) {
                        entry.target.classList.add("fade-in--is-visible");
                    }
                });
            });
            var items = document.querySelectorAll(".fade-in");
            items.forEach(function (item, index) {
                observer.observe(item, index);
            });
        } else {
            document.querySelector("body").classList.add("no-intersection-observer")
        }
    }

})(appJs);

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

appJs.InitializeFadeIn();

var blogFilter = {};

(function (blogFilterApp) {
    var filterModel = {
        Category: "latest",
        Page: 1,
        IsHome: false
    };
    var fromPopState = false;
    var blockPopstateEvent = true;
    var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

    if (browserSupportsHistoryApi) {
        // prevent Chrome from calling onpopstate on initial load
        $(window).on('load', function () {
            // The timeout ensures that popstate-events will be unblocked right
            // after the load event occured, but not in the same event-loop cycle.
            setTimeout(function () { blockPopstateEvent = false; }, 0);
        });

        $(window).on('popstate', function () {
            if (blockPopstateEvent && document.readyState === "complete") {
                return;
            }
            fromPopState = true;
            performSearchFromUrl();
        });
    }

    function pushHistory() {
        if (browserSupportsHistoryApi && !fromPopState) {
            var currentPath = window.location.pathname;
            var query = "?";
            var queryArray = [];
            if (filterModel.Category) {
                queryArray.push("category=" + filterModel.Category);
            }
            if (filterModel.Page && filterModel.Page > 1) {
                queryArray.push("page=" + filterModel.Page);
            }
            query += queryArray.join("&");
            history.pushState(null, null, currentPath + query);
        }
        fromPopState = false;
    }

    function performSearchFromUrl() {
        filterModel.Category = null;
        filterModel.Page = 1;
        if (window.location.search.length > 1) {
            for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
                 nKeyId < aCouples.length;
                 nKeyId++) {
                aItKey = aCouples[nKeyId].split("=");
                if (aItKey.length <= 1)
                    continue;
                var key = decodeURIComponent(aItKey[0]).toLowerCase();
                var val = decodeURIComponent(aItKey[1]);

                if (key === "category") {
                    filterModel.Category = val;
                } else if (key === "page") {
                    filterModel.Page = val;
                }
            }
        }
        blogFilter.GetArticles();
    }

    function setCategoryLinkActive() {
        $(".js-category-link").removeClass("is-active");
        $('.js-category-link[data-category="' + filterModel.Category + '"]').addClass('is-active');
    }

    blogFilterApp.GetArticles = function () {
        $.ajax({
            url: "/umbraco/surface/GransRemedyBlogSurface/GetFilterResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-article-filter-results").html(data);
                setCategoryLinkActive();
                pushHistory();
                appJs.InitializeFadeIn();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    blogFilterApp.GetLoadMoreArticles = function () {
        $.ajax({
            url: "/umbraco/surface/GransRemedyBlogSurface/GetLoadMoreArticles",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-load-more-results").append(data);
                $(".js-load-more").data('currentpage', filterModel.Page);
                if (filterModel.Page >= $(".js-load-more").data('pagecount')) {
                    $(".js-load-more-container").remove();
                }
                pushHistory();
                appJs.InitializeFadeIn();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    $(document).ready(function () {
        //Get url params on load
        const urlParams = new URLSearchParams(window.location.search);

        //check if querystring params exist on load/reload
        if (urlParams.get('category'))
            filterModel.Category = urlParams.get('category');

        if (urlParams.get('page'))
            filterModel.Page = urlParams.get('page');


        //on dropdown change events
        $(document).on("click", ".js-category-link", function (e) {
            e.preventDefault();
            filterModel.Category = $(this).data("category");
            filterModel.Page = 1;
            filterModel.IsHome = $(this).data("home");
            blogFilter.GetArticles();
        });

        $(document).on("click", ".js-load-more", function (e) {
            e.preventDefault();
            filterModel.Category = $('.js-category-link.is-active').data("category");
            filterModel.Page = $(this).data("currentpage") + 1;
            blogFilter.GetLoadMoreArticles();
        });
    });

})(blogFilter);
